/**
 * Card state for the newest scope order: null (nothing to show) or
 * { variant: 'processing' | 'shipped', trackingLinks: [{ label, url }] }.
 */
export const getShipmentCardState = orders => {
  const order = orders?.[0]
  if (!order) return null

  if (order.status !== 'shipped') {
    return { variant: 'processing', trackingLinks: [] }
  }

  const urls = (order.shipments || []).map(shipment => shipment?.trackingUrl).filter(Boolean)
  const trackingLinks = urls.map((url, index) => ({
    label: urls.length === 1 ? 'See tracking' : `Tracking ${index + 1}`,
    url
  }))

  return { variant: 'shipped', trackingLinks }
}
